'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reviewsCount = require('./../../src/styles/reviews-count.scss');

var _reviewsCount2 = _interopRequireDefault(_reviewsCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PatientsReviewsCount = function PatientsReviewsCount(props) {
    var reviewsCount = props.reviewsCount,
        prefix = props.prefix,
        postfix = props.postfix,
        isCountBold = props.isCountBold;


    var styles = props.classNames ? (0, _extends3.default)({}, _reviewsCount2.default, props.classNames) : _reviewsCount2.default;

    var wrapperClass = props.wrapperClass ? props.wrapperClass : null;
    return _react2.default.createElement(
        'div',
        { className: wrapperClass },
        prefix && _react2.default.createElement(
            'span',
            { className: styles['review-count__prefix'] },
            prefix
        ),
        _react2.default.createElement(
            'span',
            { className: styles['review-count__counts'] + ' ' + (isCountBold ? ' ' + styles['review-count__counts--bold'] : '') },
            reviewsCount
        ),
        postfix && _react2.default.createElement(
            'span',
            { className: styles['review-count__postfix'] },
            postfix
        )
    );
};

PatientsReviewsCount.propTypes = {
    wrapperClass: _propTypes2.default.object,
    reviewsCount: _propTypes2.default.number,
    isCountBold: _propTypes2.default.bool,
    prefix: _propTypes2.default.string,
    postfix: _propTypes2.default.string
};

PatientsReviewsCount.defaultProps = {
    reviewsCount: 0,
    isCountBold: false,
    prefix: '',
    postfix: 'patient reviews'
};

exports.default = PatientsReviewsCount;